<button (click)="toggle()" class="button" fxFlex="grow" fxHide fxShow.gt-sm mat-button>
  <mat-icon>dark_mode</mat-icon>
</button>
